const INVITE_PREFIX = 'invite:';
const USER_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isRoadmapUserId(value: string): boolean {
  return USER_ID.test(value);
}

export function roadmapInviteToken(email: string): string {
  return `${INVITE_PREFIX}${email.trim().toLowerCase()}`;
}

export function parseRoadmapTeam(team: string[] | null | undefined): {
  userIds: string[];
  pendingEmails: string[];
  legacyNames: string[];
} {
  const userIds: string[] = [];
  const pendingEmails: string[] = [];
  const legacyNames: string[] = [];
  for (const entry of team ?? []) {
    const value = entry.trim();
    if (!value) continue;
    if (value.toLowerCase().startsWith(INVITE_PREFIX)) {
      const email = value.slice(INVITE_PREFIX.length).trim().toLowerCase();
      if (email.includes('@')) pendingEmails.push(email);
      continue;
    }
    if (isRoadmapUserId(value)) userIds.push(value);
    else legacyNames.push(value);
  }
  return { userIds, pendingEmails, legacyNames };
}

export function serializeRoadmapTeam(
  userIds: string[],
  pendingEmails: string[],
  legacyNames: string[] = [],
): string[] {
  return [
    ...userIds,
    ...pendingEmails.map(roadmapInviteToken),
    ...legacyNames,
  ];
}
